module.exports = __webpack_public_path__ + "img/i_18_h.262ff5f9.png";